import { localeCountryCode } from 'services/chattt';
import toLowerCase from './toLowerCase';
import { regionBuyerDetailHostMap } from 'services/config/region';

const mercadoRegionMallMap = {
  ar: 'https://www.mercadolibre.com.ar',
  mx: 'https://www.mercadolibre.com.mx',
  br: 'https://www.mercadolivre.com.br',
  cl: 'https://www.mercadolibre.cl',
  co: 'https://www.mercadolibre.com.co',
  bo: 'https://www.mercadolibre.com.bo',
  cr: 'https://www.mercadolibre.co.cr',
  do: 'https://www.mercadolibre.com.do',
  ec: 'https://www.mercadolibre.com.ec',
  gt: 'https://www.mercadolibre.com.gt',
  hn: 'https://www.mercadolibre.hn',
  ni: 'https://www.mercadolibre.com.ni',
  pa: 'https://www.mercadolibre.com.pa',
  py: 'https://www.mercadolibre.com.py',
  pe: 'https://www.mercadolibre.com.pe',
  sv: 'https://www.mercadolibre.com.sv',
  uy: 'https://www.mercadolibre.com.uy',
  ve: 'https://www.mercadolibre.com.ve',
} as const;

/**
 * 获取 Mercado 商城首页站点
 * @param region
 * @returns
 */
export const getMercadoMallURL = (region: keyof typeof mercadoRegionMallMap) => {
  return mercadoRegionMallMap[region];
};

/**
 * 获取 Shopee 商城首页站点
 * @param region
 * @returns
 */
export const getShopeeMallURL = (region: General.CaselessRegion) => {
  let lcc = 'CN';
  if (localeCountryCode) {
    lcc = localeCountryCode;
  }

  let host = `https://${toLowerCase(region)}.xiapibuy.com`;
  if (lcc !== 'CN') {
    const r = regionBuyerDetailHostMap[toLowerCase(region)];
    if (r) {
      host = r;
    }
  }

  return host;
};

const regionLazadaRegionMap = {
  id: 'https://www.lazada.co.id',
  my: 'https://www.lazada.com.my',
  ph: 'https://www.lazada.com.ph',
  sg: 'https://www.lazada.sg',
  th: 'https://www.lazada.co.th',
  vn: 'https://www.lazada.vn',
};
/**
 * 获取 Lazada 商城首页站点
 * @param region
 * @returns
 */
export const getLazadaMallURL = (region: keyof typeof regionLazadaRegionMap) => {
  return regionLazadaRegionMap[region];
};

/**
 * 获取 Tokopedia 商城首页地址
 * @returns
 */
export const getTokopediaMallURL = () => {
  return 'https://www.tokopedia.com';
};

/**
 * 获取各电商平台商城首页地址
 * @returns
 */
export const getPlatformMallURL = (
  platform: General.PlatformCaseless,
  region?: General.CaselessRegion,
) => {
  const p = toLowerCase(platform);
  const r = toLowerCase(region);
  let url;
  if (p === 'shopee' && r) {
    url = getShopeeMallURL(r);
  }
  if (p === 'lazada' && r) {
    // @ts-ignore
    url = getLazadaMallURL(r);
  }
  if (p === 'mercado' && r) {
    // @ts-ignore
    url = getMercadoMallURL(r);
  }
  if (p === 'kwai') {
    url = 'https://m-shop.kwai.com';
  }
  if (p === 'tokopedia') {
    url = getTokopediaMallURL();
  }

  return url;
};
